import React, { useState, useEffect } from "react";
import { artistActions } from "../../actions";
import { Link } from "react-router-dom";
import styles from "./artist.module.scss";
import CircularProgress from "../../components/circularProgress";
import userStore from "../../zustand/user.store";
import { countries } from "../../constants/general.constants";

const ArtistPage = () => {
  const [artist, setArtist] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  useEffect(() => {
    if (userOffline) return;
    (async () => {
      setIsLoading(true);
      const response = await artistActions.fetchAllArtist();
      setArtist(response);
      setIsLoading(false);
    })();
  }, []);

  return (
    <>
      <h1 className={styles.header}>Artist</h1>
      {isLoading ? (
        <div className={styles.loaderContainer}>
          <CircularProgress />
        </div>
      ) : (
        <div className={styles.artistCard}>
          {artist?.map(
            (item) =>
              item.name &&
              item.last_name &&
              item.profile_img && (
                <Link
                  to={`/artists/${item.id}`}
                  key={item.id}
                  className={styles.cardInfo}
                >
                  <img
                    className={styles.image}
                    src={`${process.env.REACT_APP_BASE_URL}/media/images/${item.profile_img}`}
                    alt="artist"
                  />
                  <p className={styles.name}>{item.name}</p>
                  {countries.map((country) => {
                    if (country.value === item.country) {
                      return (
                        <p key={country.value} className={styles.lastname}>
                          {country.label}
                        </p>
                      );
                    }
                    return null;
                  })}
                  ;
                </Link>
              )
          )}
        </div>
      )}
    </>
  );
};

{
  /* <p className={styles.lastname}>{item.country}</p> */
}

export default ArtistPage;
